export default __webpack_public_path__ + "2708ffed84dd29afeb2649b0ee162cdc.jpg";